import React from 'react';
const AsyncResultProvider = /*#__PURE__*/React.lazy(() => import( /* webpackChunkName: "@atlaskit-internal_@atlassian/product-search-dialog/extensible/async/result-provider" */'./result-provider').then(({
  ResultProvider
}) => ({
  default: ResultProvider
})));
export const AsyncProvider = props => /*#__PURE__*/React.createElement(AsyncResultProvider, props, props.children);